import React from 'react';
import './CampaignStatCard.css';
import type { CampaignTypeStats } from 'types/interfaces/dripCampaign';

interface CampaignStatCardProps {
  title: string;
  icon: string;
  stats?: CampaignTypeStats;
}

const CampaignStatCard: React.FC<CampaignStatCardProps> = ({ title, icon, stats }) => {
  // Provide default values if stats is undefined or incomplete
  const scheduled = stats?.scheduled ?? 0;
  const sent = stats?.sent ?? 0;
  const pending = stats?.pending ?? 0;

  return (
    <div className="campaign-stat-card">
      <div className="stat-card-header">
        <span className="stat-card-icon">{icon}</span>
        <h3 className="stat-card-title">{title}</h3>
      </div>

      <div className="stat-card-content">
        <div className="stat-row">
          <span className="stat-label">Scheduled:</span>
          <span className="stat-value">{scheduled}</span>
        </div>

        <div className="stat-row">
          <span className="stat-label">Sent:</span>
          <span className="stat-value stat-value-success">{sent}</span>
        </div>

        <div className="stat-row">
          <span className="stat-label">Pending:</span>
          <span className="stat-value stat-value-warning">{pending}</span>
        </div>
      </div>
    </div>
  );
};

export default CampaignStatCard;
